module.exports = "/assets/76f0ad043a342b13356d6ccb6811deb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/CO.png
// module id = 1272
// module chunks = 0